<template>
  <b-modal
    :active.sync="isModalActive"
    :width="640"
    scroll="keep"
    :on-cancel="cancelSubmit"
  >
    <div
      class="relative flex flex-col p-4 bg-white border rounded shadow border-blue-light"
      @dragenter.prevent="onDragEnter"
      @dragleave.prevent="onDragLeave"
      @dragover.prevent
      @drop.prevent="onDrop"
    >
      <div
        v-if="isDragging"
        class="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white border-4 border-dashed rounded border-blue pointer-events-none"
        style="background-color: rgba(255,255,255,0.95);"
      >
        <b-icon icon="cloud-upload-alt" pack="fas" size="is-large" type="is-primary"></b-icon>
        <p class="mt-2 text-lg font-semibold text-blue">{{ $t('drop_files_here') }}</p>
      </div>

      <div class="flex flex-col w-full" v-if="actionType === actionTypes.REGISTER">
        <div class="font-semibold uppercase text-blue">{{ $t(modalTitle) }}</div>
        <div class="text-blue">{{ $t(modalBody) }}</div>
      </div>
      <div class="flex flex-col w-full" v-if="actionType === actionTypes.RESOLVE_ISSUE">
        <div class="font-semibold uppercase text-blue">{{ $t('resolve_issue') }}</div>
        <!-- <div class="text-blue">{{ $t('delete_issue') }}</div> -->
      </div>

      <div class="flex flex-col w-full" v-if="actionType === actionTypes.CREATE_ISSUE">
        <div class="font-semibold uppercase text-red">{{ $t('add_issue') }}</div>
        <!-- <div class="text-red">{{ $t('add_issue') }}</div> -->
      </div>

      <div class="flex flex-col w-full" v-if="actionType === actionTypes.CREATE_LOCK_TYPE">
        <div class="font-semibold uppercase text-red">{{ $t('add_lock_type') }}</div>
        <div class="text-red">{{ $t('select_type') }}</div>
      </div>

      <form>
      <div class="flex flex-col w-full mt-4">
        <!-- campo progress -->
        <div v-if="actionType === actionTypes.REGISTER">
          <label class="text-xs font-medium text-blue">{{ $t('progress') }}:</label>
          <input class="w-1/2 p-2 text-xs border rounded bg-grey-lighter border-grey-light" type="number" v-model.number="newValue" @input="update" min="0" max="100" />

        </div>
        <!-- campo select block type -->
        <div>
          <select
            v-if="actionType === actionTypes.CREATE_LOCK_TYPE"
            v-model="lockType"
            required
            :placeholder="$t('select_type')"
            class="w-full p-2 mt-4 text-xs border rounded bg-grey-lighter border-grey-light">
            <option :value="22">{{ $t('task_issue_without_blocking') }}</option>
            <option :value="23">{{ $t('task_issue_with_task_blocking') }}</option>
            <option :value="24">{{ $t('task_issue_with_activity_blocking') }}</option>
            <option :value="28">{{ $t('task_issue_with_parent_activity_blocking') }}</option>
            <option :value="25">{{ $t('task_issue_with_project_blocking') }}</option>
          </select>
        </div>

        <template v-if="actionType === actionTypes.REGISTER">
          <div class="progress-container">

            <div class="custom-progress-bar">
              <!-- Valor base -->
              <div class="segment base" :style="{ width: baseWidth + '%' }" ></div>

              <!-- Incremento: verde -->
              <div v-if="delta > 0" class="segment increase" :style="{ width: delta + '%' }"></div>

              <!-- Decremento: rojo -->
              <div v-if="delta < 0" class="segment decrease" :style="{ width: Math.abs(delta) + '%', marginLeft: newValue + '%' }" ></div>

              <span class="progress-text">{{ newValue }}%</span>
            </div>

          </div>
        </template>
        <!-- campo fecha  -->
        <div class="flex flex-col" v-if="actionType === actionTypes.REGISTER">
          <div class="text-xs font-medium text-blue">{{ $t("date") }}</div>
          <div class="flex flex-row w-full">
            <b-field>
              <b-datepicker
                v-model="form.date"
                title="date"
                name="date"
                :placeholder="$t('date')"
                :required="true"
                class="w-full"
                icon-pack="fas"
                icon="calendar"
                :first-day-of-week="parseInt($t('first_day_of_week'))"
                :max-date="today"
              ></b-datepicker>
            </b-field>
          </div>
        </div>
        <div class="flex flex-col">
            <div class="text-xs font-medium text-blue">{{ $t("observations") }}</div>
            <div class="flex flex-row w-full">
              <textarea
                v-model="form.observation"
                title="observation"
                name="observation"
                maxlength="2000"
                :placeholder="$t('observations')"
                class="w-full h-36 p-2 text-xs border rounded bg-grey-lighter border-grey-light"
              />
            </div>
        </div>
        <div class="flex flex-col mt-4">

            <b-field class="file is-primary">
              <b-upload
                v-model="files"
                class="file-label"
                :multiple="true"
                :accept="accept"
              >
                <span class="file-cta">
                  <span class="mr-2 file-label">{{
                    $t("upload_documents")
                  }}</span>
                  <b-icon class="file-icon" icon="upload" pack="fas"></b-icon>
                </span>
              </b-upload>
            </b-field>
            <p class="mt-1 text-xs text-grey">{{ $t('select_or_drag_and_drop_files') }}</p>


              <div class="flex flex-col mt-3" v-if="filesSelected">
                <div
                  v-for="(file, index) in files"
                  :key="index"
                  class="flex items-center px-3 py-2 mb-2 border rounded bg-grey-lighter border-grey-light"
                >
                  <b-icon :icon="fileIcon(file)" pack="fas" type="is-primary"></b-icon>
                  <div class="flex-1 min-w-0 mx-2">
                    <div class="text-xs font-medium text-black truncate" :title="file.name">{{ file.name }}</div>
                    <div class="text-xs text-grey">{{ formatFileSize(file.size) }}</div>
                  </div>
                  <button
                    type="button"
                    class="text-grey hover:text-red"
                    @click="removeFile(index)"
                    :title="$t('delete')"
                  >
                    <b-icon icon="times-circle" pack="fas"></b-icon>
                  </button>
                </div>
              </div>


            <b-field class="file is-primary">
              <!-- buttom select -->
              <div class="flex flex-row justify-between w-full mt-4">
                <div class="flex flex-col">
                  <b-button
                    @click="showModalSelectFolder = true"
                    type="is-grey"
                    :disabled="!filesSelected"
                    icon-pack="fas"
                    icon-left="copy"
                    >
                    {{ $t('select_folder') }}
                  </b-button>
                </div>
              </div>
            </b-field>

            <!-- ruta COMPLETA  -->
            <div v-if="targetFolder.fullRoute" class="flex flex-col mt-4">
              <div class="text-xs font-medium text-blue">{{ $t("destination_folder") }}</div>
              <div class="flex flex-row w-full">
                <span class="text-xs font-medium text-grey">
                  {{ targetFolder.fullRoute }}
                </span>
              </div>
            </div>

            <div v-if="isLoading" class="my-4 text-center">
              <scale-loader />
            </div>

        </div>

      </div>

      <div class="flex flex-row items-center justify-end w-full mt-6">

        <!-- cancel -->
        <a @click.prevent="cancelSubmit" :disabled="isLoadignRegister" class="mr-4 text-red">
          {{ $t("cancel") }}
        </a>

        <!-- complete, create issue, etc -->
        <b-button
          v-if="actionType === actionTypes.REGISTER " :loading="isLoadignRegister"
          type="is-success"
          @click="onComplete()" class="btn btn-green"  >
            {{ $t("complete_resource")  }}
        </b-button>
        <b-button  v-if="actionType === actionTypes.CREATE_ISSUE"
          type="is-primary"
          :loading="isLoadignRegister"
          @click.prevent ='submitForm()'
          class="btn btn-blue"  :disabled="isLoading">{{ $t("add_issue") }}
        </b-button>
        <b-button  v-if="actionType === actionTypes.CREATE_LOCK_TYPE"
          type="is-primary"
          @click.prevent ='submitForm()'
          :loading="isLoadignRegister"
          class="btn btn-blue"
          :disabled="isLoading">{{ $t("add_lock_type") }}
        </b-button>

        <!-- save -->
        <b-button  v-if="actionType === actionTypes.REGISTER || actionType === actionTypes.RESOLVE_ISSUE"
          @click.prevent ='submitForm()'
          :loading="isLoadignRegister"
          type="is-primary"
          class="btn btn-blue ml-2"  :disabled="isLoading">{{ $t("save") }}
        </b-button>

      </div>
      </form>

      <b-modal v-model="showModalSelectFolder" size="lg" scroll="keep">
        <div class="flex flex-col border border-blue-light rounded shadow bg-white p-4">
          <select-folders
          :folderId="moveFolderId"
          :documentId="entityId"
          :parentId="selectedEntityId"
          :callbackFunction="onSelectFolder"
          :defaultFolder="targetFolder"
          @close="openFolder(lastSelectedFolder)" />
        </div>
      </b-modal>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import uploadDocument from "./upload-document";
import EventBus from "~/plugins/bus";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import Uppy from '@uppy/core'
// import AwsS3Multipart from '@uppy/aws-s3-multipart'
import AwsS3 from '@uppy/aws-s3';
import store from "~/store";
import selectFolders from "./assignments/select-folders.vue";
import filesDragDropMixin from "·/mixins/files-drag-drop-mixin";

export default {
  name: "assignment-register-task-modal",

  mixins: [filesDragDropMixin],

  components: {
    uploadDocument,
    ScaleLoader,
    selectFolders,
  },

  props: {
    entityId: { type: Number, required: true },
    entityType: { type: String, required: true },
    activityId: { type: Number, required: false, default: null },
    subactivityId: { type: Number, required: false, default: null },
    activityName: { type: String, required: false, default: null },
    filterUploadType: {
      type: Object,
      default: () => ({ filter: false }),
      required: false,
    },
  },

  data: () => ({
    isModalActive: false,
    modalTitle: "",
    modalBody: "",
    id: null,
    completed: null,
    isLoading: false,
    isLoadignRegister: false,
    data: {},
    form: {
      date: null,
    },
    files: [],
        cancelRequest: null,
    types: {
      0: "application/*",
      1: "image/*",
      2: "audio/*",
      3: "video/*",
    },
    accept: "", // on created()
    uppy: null, // instancia de la libreria para subir archivos
    keyFileUploadCurrent: null, // key del archivo que se esta subiendo actualmente
    uploadPercentage: 0,

    showModalSelectFolder: false,
    selectedEntityId: null,
    moveDocumentId: null,
    moveFolderId: null,
    targetFolder:{
      folderId: null,
      activityId: null,
      folderName: null,
      activityName: null,
      fullRoute: null,
    },

    assignment: {},

    baseValue: 0,
    newValue: 0,
    delta: 0,
    isReal: false,

    valueExecuted1: 0,
    lockType: null,
    actionType: null,
    actionTypes : {
      REGISTER: 1,
      CREATE_ISSUE:2,
      CREATE_LOCK_TYPE:3,
      RESOLVE_ISSUE:4,
    }
  }),

   created(){

    this.accept = this.$acceptedExtensions // extensiones aceptadas
    /**
     * Establecemos los tipos de archivos que permitimos subir
     * segun los parametros pasados
     */
    if(this.filterUploadType.filter){
      this.accept = "";
      this.filterUploadType.types.forEach(type => {
        this.accept += this.types[type]+",";
      });
    }

    this.uppy = new Uppy({
        debug: process.env.NODE_ENV === 'development', // activamos debug para development
        autoProceed: false,
        allowMultipleUploads: false,
      })
      .use(AwsS3, {
        shouldUseMultipart: true,
        limit: 3,
        companionUrl: '/api/v2/',
        endpoint: '/api/v2/',
        headers: {
          'Authorization': "Bearer " + store.getters["auth/token"]
        }
      })
      // .on('upload-success', (file, response) => { this.onUploadSuccess(file, response) } )
      .on('upload-success', (file, response) => { // callback deveulto cuando el file ha sido subido correctamente
        console.log('%cEPC-TACKER: '+ '%c file ' + file.data.name + ' subido correctamente', 'background: #5577BB; color: #fff', 'color: #000')
      })
      .on('upload-progress', (file, progesss) => { // callback devuelto con el progreso de subido del archivo
        this.uploadPercentage = parseInt(
          Math.round((progesss.bytesUploaded * 100) / progesss.bytesTotal)
        );
      })
      .on('upload-error', (file, error, response) => { // callback devuelto si ha ocurrido algun error en la subida
        console.error('%cEPC-TACKER: '+ '%c a ocurrido un error al subir el archivo ' + file.data.name, 'background: #5577BB; color: #fff', 'color: #000', error)
      })
  },


  computed: {

    ...mapGetters({
      project: "app/project",
    }),

    filesSelected() {
      return this.files.length > 0 || this.files.size > 0;
    },

    baseWidth() {
      return this.delta < 0 ? this.newValue : this.baseValue
    },

    today() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return today
    }

  },

  watch: {
    newValue(newVal) {
      const valueExecuted = this.calculateExecutedAdjustment(
        this.isReal ? this.assignment.actual_progress : this.assignment.executed_quantity,
        newVal
      );

      this.valueExecuted1 = valueExecuted;
    },
  },

  methods: {
    onAddClicked() {
      this.$refs.modal.show();
    },

    updateProgress() {
      this.delta = this.newValue - this.baseValue
    },

    update() {
      this.delta = this.newValue - this.baseValue
    },

    /**
     * Cancelamos el envio del formulario y refrescamos la lista
     * para quitar check
     */
    cancelSubmit() {
      // this.$emit("reload");
      this.hide();
    },

    onComplete() {
      this.$dialog.confirm({
        title: this.$t("complete"),
        message: this.$t("complete_measurement"),
        confirmText: this.$t("complete"),
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
            this.valueExecuted1 = this.calculateExecutedAdjustment(
              this.isReal ? this.assignment.actual_progress : this.assignment.executed_quantity,
              100
            );
            this.newValue = 100;
            this.submitForm();
        }
      });
    },
    /**
     * Envía el formulario para completarlo
     */
    async submitForm() {

      let url = "/api/v2/assignment/" + this.id + "/task-register";

      let processedDate = this.processDate(this.form.date); // transformamos la fecha a formato YYYY-MM-DD

      let data = {
        observation: this.form.observation,
        completed: this.newValue == 100 ? 1 : 0,
        start_date: processedDate,
        end_date: processedDate,
        value_executed: this.valueExecuted1,
        is_real_progress: this.isReal,
        action_type: this.actionType,
        lock_type: this.lockType,
      };

      if (data.action_type === this.actionTypes.CREATE_LOCK_TYPE && !data.lock_type) {
        this.$notify.error("select_type");
        return;
      }

      self = this;
      this.isLoadignRegister = true;
      axios
        .post(url, data)
        .then(function (response) {
          if (response.data.error) {
            self.$notify.error(response.data.error);
            this.cancelSubmit();
          } else {
            self.$notify.success("updated_successfully");
            // sacamos la linea creada para obtener su id
            let line = response.data.line;
            if (data.action_type === self.actionTypes.CREATE_LOCK_TYPE) {
              if ([23, 24, 25, 28].includes(data.lock_type)) {
                self.addIssue(line.id);
              }
            }
          }
        })
        .catch((error) => {
          self.$notify.error("update_error");
          this.cancelSubmit();
        }).finally(() => {
          this.$emit("reload");
          this.hide();
          this.isLoadignRegister = false;
          EventBus.$emit("refreshActivityDocumentsNotifications", true);
        });

      if (this.filesSelected) {
        await this.uploadFilesAll();
      }


    },

    removeFile(index) {
      this.files.splice(index, 1);
    },

    processDate(date) {
      // let d = new Date(date);
      // return d.toISOString().slice(0, 10); // quitado  porque esto transforma la fecha a UTC y puede haber diferencia de 1 dia
      // Tomamos la fecha seleccionada, sin timezones ni ostias
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },


    async uploadFiles() {
      if (this.files.length == 0) {
        return;
      }

      this.isLoading = true;
      let files = this.files.slice();
      for (var i = files.length - 1; i >= 0; i--) {
        if (files[i].size / 1024 / 1024 > 1024) {
          this.$notify.warning("document_exceeded_max_size", {
            name: files[i].name,
          });
        } else {
          let ok = await this.submitFile(files[i]);
          if (ok) {
            this.files.splice(i, 1);
            this.$notify.success("upload_document_success", {
              files: files[i].name,
            });
          } else {
            this.isLoading = false;
            this.$notify.error("upload_document_error");
            return false;
          }
        }
      }

      // Todos los ficheros subidos
      if (this.files.length == 0) {
        this.isLoading = false;
        this.$notify.success("upload_document_success", {
          files: files.length,
        });
        this.$emit("success");
        return true;
      }
    },

    calculateProgress(weight, executed_quantity) {
      if (!weight || weight === 0) return 0; // evita división por cero
      return (executed_quantity / weight) * 100;
    },

    async uploadFilesAll() {
      if (this.files.length == 0) {
        return;
      }
      this.isLoading = true;

      let countFiles = this.files.length;
      let countFilesSuccess = 0;

      for (const file of this.files) {
        try {
          if (file.size / 1024 / 1024 > 1024) {
            this.$notify.warning("document_exceeded_max_size", {
              name: file.name,
            });
          } else {
            const result = await this.submitFile(file);

            countFilesSuccess++;
            // si es el ultimo archivo, cambiamos el estado de carga
            if (countFilesSuccess + 1 > countFiles) {
              this.isLoading = false;
            }

          }
        } catch (error) {
          console.error(`Error en el archivo ${file.name}:`, error);
          this.$notify.error(`Error crítico al subir ${file.name}`);
        }
      }
    },

    async submitFile(file) {

      this.uploadPercentage = 0
      this.cancelRequest = axios.CancelToken.source();

      let form = new FormData();

      let customName = "";
      if (file.custom_name) customName = file.custom_name.trim();

      // Si el nombre personalizado después del trim tiene contenido usamos ese, y si no pasamos al del fichero
      form.append(
        "original_filename",
        customName != "" ? customName + this.getFileExtension(file) : file.name
      );
      form.append("entity_type", "assignment");
      form.append("entity_id", this.id);

      form.append("project_id", this.project.id)

      // si existe forlderId lo añadimos al form
      if (this.targetFolder.folderId) {
        form.append("folder_id", this.targetFolder.folderId);
      }


      return this.store(file, {}).then(async result => {

          // successFul contiene toda la lista de archivos que se han subido
          // para nuestro caso solo consideramos siempre el primero por que enviamos de a uno
          if( result.successful.length > 0 ) {
            let response = result.successful[0].response

            let params = {
              // uuid: response.uuid,
              key: response.body.key,
              // bucket: response.bucket,
              name: file.name,
              content_type: file.type,
              // url: response.url
            }

            form.append("aws_response", JSON.stringify(params));

            let resp = null
            resp = axios.post("/api/v2/" + this.entityType + "/" + this.entityId + "/document", form, {
               cancelToken: this.cancelRequest.token,
            });

            return resp && resp.data && resp.data.success ? resp.data.success : false
          }

          // failed contiene todos los archivos que tubieron fallo al subir
          if (result.failed.length > 0) {
            console.error('Errors:')
            result.failed.forEach((file) => {
              console.error(file.error)
            })

            return false
          }
      }).catch((error) => {
        console.log(error);
        return false
      });

    },

    // CUSTOM VAPOR STORE METHOD
    async store(file, options = null) {

      // verificamos si existe algun archivo en la lista de carga de uppy
      // si existe lo eliminamos
      if( this.keyFileUploadCurrent ) {
        this.uppy.removeFile(this.keyFileUploadCurrent);
      }

      if (typeof options.progress === 'undefined') {
          options.progress = () => {};
      }

      this.keyFileUploadCurrent = this.uppy.addFile({
        name: file.name, // file name
        type: file.type, // file type
        data: file, // file blob
        // meta: {
        //   // optional, store the directory path of a file so Uppy can tell identical files in different directories apart.
        //   relativePath: webkitFileSystemEntry.relativePath,
        // },
        source: 'Local',
        isRemote: false,
      });

      // response.data.extension = file.name.split('.').pop()
      return this.uppy.upload()
    },

    /**
     * funcion para seleccionar la carpeta de destino
     */
    onSelectFolder( folderId, ActivityId, folderName, activityName, fullRoute ) {
      this.targetFolder.folderId = folderId
      this.targetFolder.activityId = ActivityId
      this.targetFolder.folderName = folderName
      this.targetFolder.activityName = activityName
      this.targetFolder.fullRoute = fullRoute

      this.showModalSelectFolder = false

    },

    addIssue(lineId) {
      const params = {
        activityName: this.activityName,
        assignmentId: this.id,
        lineId: lineId
      }

      // Compatibilidad: este modal ya se usaba en Activity Home funcionando.
      // Solo añadimos estos params en el nuevo flujo (assignment-table) cuando vienen informados.
      if (this.activityId != null) {
        params.activity_id = this.activityId
      }
      if (this.subactivityId != null) {
        params.subactivity_id = this.subactivityId
      }

      this.$router.push({
        name: this.subactivityId ? 'subissue.create' : 'issue.create',
        params
      })
    },

    /**
     * Muestra este modal
     */
    show(assignment, isReal, action = this.actionTypes.REGISTER) {
      this.id = assignment.id;
      this.completed = assignment.completed;
      this.isModalActive = true;
      this.isReal = isReal;
      this.assignment = assignment;

      // actions puede ser 'register', create_issue, CREATE_LOCK_TYPE
      this.actionType = action;


      this.form.date = new Date()
      // calculamoss el progreso
      this.baseValue = this.isReal ? assignment.actual_progress : assignment.executed_quantity;
      // this.calculateProgress(
      //   assignment.weight,
      //   this.isReal? assignment.actual_progress : assignment.executed_quantity
      // );
      this.newValue = this.baseValue;
      this.delta = 0;
      this.valueExecuted1 = 0;

      this.modalTitle = this.isReal? "real_progress_update": "inspected_progress_update";
      this.modalBody = this.isReal? "register_real": "register_inspect";

    },

    calculateExecutedAdjustment(executed_quantity, newValue) {
      return Math.round((newValue - executed_quantity) * 100) / 100;
    },

    /**
     * valores por defecto del formulario
     */
    defaultFormValues() {
      return {
        observation: "",
      };
    },

    /**
     * Oculta este modal
     */
    hide() {
      this.id = null;
      this.data = [];
      this.isModalActive = false;
      this.form = this.defaultFormValues();
      //resetamos archivos
      this.files = [];
    },
  },
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
.progress-container {
  width: 100%;
  margin: 20px auto;
}

.custom-progress-bar {
  height: 25px;
  background: #eee;
  border-radius: 5px;
  display: flex;
  position: relative;
  overflow: hidden;
  margin: 10px 0;
}

.segment {
  height: 100%;
}

.base {
  background-color: #3498db; /* azul */
}

.increase {
  background-color: #2ecc71; /* verde */
}

.decrease {
  background-color: #e74c3c; /* rojo */
  position: absolute;
  top: 0;
  height: 100%;
}

.progress-text {
  position: absolute;
  left: 50%;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(-50%);
  font-weight: bold;
  color: white;
}

.text-green {
  color: #2ecc71;
}

.text-red {
  color: #e74c3c;
}

</style>
